import { post } from '@/api';
export const shareApi = ({ articleId, shareType }) => {
    const data = {
        counterType: 'SHARE',
        gaClientId: localStorage.getItem('ga-client-id'),
        shareType, // FB、LINE、COPY、RESERVE
    };
    post(
        `/api/counter/share/${articleId}/increase`,
        data
    );
};
